import Header from '../../components/Header'
import HeaderImage from '../../Imagenes/IMG_3821.JPG'

// SALA ETERNIDAD
import ImageEternidad1 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA ETERNIDAD/WhatsApp Image 2021-02-08 at 09.43.23 (1).jpeg'
import ImageEternidad2 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA ETERNIDAD/WhatsApp Image 2021-03-22 at 10.51.22.jpeg'
import ImageEternidad3 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA ETERNIDAD/IMG_4388.JPG'

// SALA ESPERANZA
import ImageEsperanza1 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA ESPERANZA/WhatsApp Image 2021-02-08 at 09.43.23 (1).jpeg'
import ImageEsperanza2 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA ESPERANZA/IMG_4382.JPG'
import ImageEsperanza3 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA ESPERANZA/IMG_3823.JPG'

// SALA FE
import ImageFe1 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA FE/WhatsApp Image 2021-02-08 at 09.43.23 (2).jpeg'
import ImageFe2 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA FE/IMG_3943.JPG'
import ImageFe3 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA FE/IMG_4389.JPG'

// SALA FRATERNIDAD
import ImageFraternidad1 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA FRATERNIDAD/IMG_3822.JPG'
import ImageFraternidad2 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA FRATERNIDAD/IMG_4383.JPG'
import ImageFraternidad3 from '../../Imagenes/página web/SALAS GUAYAQUIL/SALA FRATERNIDAD/IMG_4390.JPG'
import SalaCard from "../../components/SalaCard";
import React, { useEffect } from 'react';
import './wakeRooms.css'

const WakeRooms = () => {

  useEffect(() => { /*Para ver desde el principio de la página */
    window.scrollTo(0, 0);
  }, []);

  return (
     <main className="roomsg-page">

       {/* HEADER */}
      <Header
        title="Salas de Velación Guayaquil"
        image={HeaderImage}
      >
         Contamos con 4 salas premium con capacidad para 120 personas.
      </Header>
  
    <section className="wake-room">
      <SalaCard
        title="Sala Eternidad"
        description="Capacidad para 120 personas · Cafetería · 2 salas de descanso · Baños privados · Transmisión virtual · WIFI · Parqueaderos · Seguridad privada"
        images={[ImageEternidad1, ImageEternidad2, ImageEternidad3]}
      />

      <SalaCard
        title="Sala Esperanza"
        description="Capacidad para 120 personas · Cafetería · 2 salas de descanso · Baños privados · Transmisión virtual · WIFI · Parqueaderos · Seguridad privada"
        images={[ImageEsperanza1, ImageEsperanza2, ImageEsperanza3]}
      />

      <SalaCard
        title="Sala Fe"
        description="Capacidad para 120 personas · Cafetería · 2 salas de descanso · Baños privados · Transmisión virtual · WIFI · Parqueaderos · Seguridad privada"
        images={[ImageFe1, ImageFe2, ImageFe3]}
      />

      <SalaCard
        title="Sala Fraternidad"
        description="Capacidad para 120 personas · Cafetería · 2 salas de descanso · Baños privados · Transmisión virtual · WIFI · Parqueaderos · Seguridad privada"
        images={[ImageFraternidad1, ImageFraternidad2, ImageFraternidad3]}
      />

    </section>
    
    
    </main>
    
  )
}

export default WakeRooms
